/*=================================================
    summary: 練習 拼一拼 聽寫拼音    LUSeqNo: 12    拼音填空題型
             Practice Pinyin Dictation

    remarks: 000 Tim 2022/01/11 Create
             001 Tim 2022/01/14 串接 LanguageChangeHandler 流程
             002 Tim 2022/03/14 補上 BlockedInstructor 機制
=================================================*/
import React, { useEffect, useState, useContext, useRef } from 'react'
import cssPracticePinyinDictation from './PracticePinyinDictation.module.scss'
import { LUCacheContext, GoToLUSinceActionEnum } from '../../LearningUnit.js';
import {TestSheetModeEnum } from '../Component/CompositionContent/CompositionContent'
import parse from 'html-react-parser'
import {ClientGatewayInPackage, GoogleShareToClassRoom, GlobalLibs, NetworkLibs, PackageVariablesLibs} from 'bc-react-package'

// #region Constant
const COMP_NAME = "PracticePinyinDictation"

const MAX_ANSWER_CHARACHERS = 128 // Textarea最大的數字限制
// #endregion Constant

// #region Member Variables
let mblnInitialized = false

let mobjCallParam = null
let mstrLUKey4LUCachedContext = "" // 用於從LUCacheContext 取出 Cache的LU資料時 指出此LU時所需的Key
let mstrBookCatID = ""
let mstrLUCatSeqNo = ""
let mintAccountRole = 0
let mintClassID = -1

let mintIndex4HistoryItemToShow = -1
let mobjTestSheet = {
    "Mode": 1,    // TestSheetModeEnum.New
    "Score": -1,
    "Dirty": false,
    "AnswerList": [],
    "AssignID": -1
}

let mstrInstruction = ""
let mobjDisplaySubSubSection = {
    "NameEN": "",
    "NameCN": ""
}
let marrDisplayQuestion = []

let mstrMessage4BlockedInstructor = ""
// #endregion Member Variables

function PracticePinyinDictation(props)
{
    console.log(COMP_NAME + ".Begin:", props)
    console.log(COMP_NAME + ".props.LUInfo: ", props.LUInfo)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [playAudioIndex, setPlayAudioIndex] = useState(-1)
    const [answerArray, setAnswerArray] = useState([])
    const [isBlockedInstructor, setIsBlockedInstructor] = useState(false)
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Function Ref

    // #region Init Context Ref
    let mobjLUCacheContext = useContext(LUCacheContext) // 包含所有的歷史作答答案
    console.log("mobjLUCacheContext: ", mobjLUCacheContext)
    // #endregion Init Context Ref
    
    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
        console.log("GoToLUSinceActionEnum: ", GoToLUSinceActionEnum)
        console.log("GoToLUSinceAction: ", props.GoToLUSinceAction)
        
        mstrBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)
        mintAccountRole = window.Globals.GetClassAccountRole(window.gSession.Acc.CurrentClassIndex)

        if (
            (typeof (window.gSession.Acc.Class) !== 'undefined') &&
            (window.gSession.Acc.Class !== null) &&
            (window.gSession.Acc.Class.length > 0) &&
            (window.gSession.Acc.CurrentClassIndex >= 0) &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
            (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) !== 'undefined') &&
            (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID !== null) &&
            (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) > 0)
            )
        {
            mintClassID = parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID)
        }
        else
        {
            mintClassID = -1
        }

        mblnInitialized = true
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // #region useEffect
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")

            // 避免離開這個 LU 還收到 Audio Player 的 Callback
            window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
            window.AudioLibs.StopAudio()

            mblnInitialized = false
            mstrLUKey4LUCachedContext = ""
            mstrBookCatID = ""
            mstrLUCatSeqNo = ""
            mintAccountRole = 0
            mintClassID = -1
            mintIndex4HistoryItemToShow = -1
            mobjTestSheet = {
                "Mode": 1,    // TestSheetModeEnum.New
                "Score": -1,
                "Dirty": false,
                "AnswerList": [],
                "AssignID": -1
            }   

            mstrInstruction = ""
            mobjDisplaySubSubSection = {
                "NameEN": "",
                "NameCN": ""
            }

            mstrMessage4BlockedInstructor = ""

            setIsBlockedInstructor(false)
            setUpdateDataTime(0)
            setPlayAudioIndex(-1)
            setAnswerArray([])
            mrefCleanUp.current()
        }
    }, [props.LUInfo])
    // #endregion useEffect

    // #region Painted Me
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2022/01/11 Create
             001 Jeff 2022/01/13 增加 註冊 語言改變事件  Tim幫忙註解
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe: ")

        RegisterLanguageChangeHandler()
        RegisterGlossaryCallback()

        mstrLUKey4LUCachedContext = "LU" + props.LUInfo.LUCatSeqNo // 用於Cache LU資料時 指出此LU的Key
        mstrLUCatSeqNo = props.LUInfo.LUCatSeqNo
        mstrInstruction = props.LUInfo.Instruction.replace(/\n/g, "<br>")

        console.log(COMP_NAME + ".PaintedMe mstrLUKey4LUCachedContext: ", mstrLUKey4LUCachedContext)
        console.log(COMP_NAME + ".PaintedMe mstrLUCatSeqNo: ", mstrLUCatSeqNo)

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        let objHistoryList = mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext]
        if (
            (typeof (objHistoryList) === 'undefined') || 
            (objHistoryList === null) || 
            (typeof (objHistoryList.LessonID) === 'undefined') || 
            (objHistoryList.LessonID === null) || 
            (parseInt(objHistoryList.LessonID) <= 0) || 
            (objHistoryList.LessonID !== props.LessonID)
            )
        {
            console.log("need to get Assignment History")

            GetPrerequisiteDataProcessBegin()
        }
        else
        {
            console.log("need Not to get Assignment History")
            GetPrerequisiteDataProcessEnd()
        }
    } // end of PaintedMe

    /*===========================================
    summary: componentWillUnmount 程式離開 處理離開流程
    remarks: 000 Jeff 2022/01/13 Create  Tim幫忙註解
    ===========================================*/
    function CleanUp()
    {
        console.log(COMP_NAME + ".CleanUp: ")

        UnregisterLanguageChangeHandler()
        UnregisterGlossaryCallback()
    } // end of CleanUp
    // #endregion Painted Me

    // #region OnTapHandler
    // #region Google Classroom
    /*===========================================
    summary: App 點選 GoogleClassroom 元件
    remarks: 000 Tim 2022/01/03 Create
             001 Tim 2023/06/19 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function Share2GoogleClassroom4AppOnTapHandler()
    {
        console.log(COMP_NAME + ".Share2GoogleClassroom4AppOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.StopAudio()
        setPlayAudioIndex(-1)


        let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(props.LUInfo.LUCatSeqNo)
        console.log("Share2GoogleClassroom4AppOnTapHandler strUrl: ", encodeURIComponent(strUrl))

        // In App
        let intAction = window.gConst.ACTION_OEPN_APP_SHARE_WITH_URL
        let intPositionX = 54 // 視窗的小箭頭位置
        let intPositionY = 112 // 視窗的小箭頭位置

        let strQueryString = "Action=" + intAction
        strQueryString += "&Credential=" + window.gSession.Acc.Credential
        strQueryString += "&BackRoute="
        strQueryString += "&Url=" + encodeURIComponent(strUrl)
        strQueryString += "&PosX=" + intPositionX.toString()
        strQueryString += "&PosY=" + intPositionY.toString()

        console.log("Share2GoogleClassroom4AppOnTapHandler strQueryString: ", strQueryString)

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
        ClientGatewayInPackage.CallApp(strQueryString)
    } // end of Share2GoogleClassroom4AppOnTapHandler
    // #endregion Google Classroom

    /*===========================================
    summary: 點選 子子單元
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function SubSubSectionOnTapHandler(LUCatSeqNo)
    {
        console.log(COMP_NAME + ".SubSubSectionOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.StopAudio()
        setPlayAudioIndex(-1)

        GoToLU(LUCatSeqNo)
    } // end of SubSubSectionOnTapHandler

    /*===========================================
    summary: 點選 說明資訊按鈕
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function InfoOnTapHandler()
    {
        console.log(COMP_NAME + ".InfoOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.StopAudio()
        setPlayAudioIndex(-1)

        let objAlertObject = {
            Header: window.gAppUI.MSG_PinyinDictationInfo_Title,
            Body: window.gAppUI.MSG_PinyinDictationInfo_Msg,
            ShowCloseButton: false,
            CallbackRef: null,
            Buttons: [
                {
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)
    } // end of InfoOnTapHandler

    /*===========================================
    summary: 按下 歷史紀錄 按鈕
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function HistoryOnTapHandler()
    {
        // console.log(COMP_NAME + ".HistoryOnTapHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".HistoryOnTapHandler BEGIN")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.StopAudio()
        setPlayAudioIndex(-1)

        console.log("mobjLUCacheContext:", mobjLUCacheContext)
        let objCallbackData = {
            "Action": "HistoryWindowOpen",
            "CallbackRef": HistoryWindowCallback,
            "LessonID": props.LessonID,
            "AssigementHistoryList": mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList,
            "AssignmentTempAns": null
        }
        props.CallbackRef(objCallbackData)
    } // end of HistoryOnTapHandler

    /*===========================================
    summary: 按下 重新開始 按鈕
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function TryAgainOnTapHandler()
    {
        // console.log(COMP_NAME + ".TryAgainOnTapHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".TryAgainOnTapHandler BEGIN")  
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.StopAudio()
        setPlayAudioIndex(-1)

        let enumTestSheeMode = TestSheetModeEnum.New
        SetTestSheetObject(enumTestSheeMode)

        marrDisplayQuestion = FormatPDQuestionData(props.LUInfo, mobjTestSheet)
        setUpdateDataTime(new Date().getTime())
        console.log(COMP_NAME + ".TryAgainOnTapHandler marrDisplayQuestion: ", marrDisplayQuestion)
    } // end of TryAgainOnTapHandler

    /*===========================================
    summary: 按下 送出作答資料 按鈕
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function SubmitOnTapHandler(StateAnswerArray)
    {
        // console.log(COMP_NAME + ".SubmitOnTapHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".SubmitOnTapHandler BEGIN")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.StopAudio()
        setPlayAudioIndex(-1)

        // 將 State 紀錄的答案 放進 TestSheet
        StateAnswerArray.forEach((AnswerData, AnswerIndex) => {
            mobjTestSheet.AnswerList[AnswerIndex].PDAnswer = AnswerData
        })

        console.log("AnswerList: ", mobjTestSheet.AnswerList)

        mobjCallParam = {
            "BookCategoryID": mstrBookCatID,
            "LessonID": props.LessonID,
            "ClassID": mintClassID,
            "LUCatSeqNo": props.LUInfo.LUCatSeqNo,
            "AnswerList": mobjTestSheet.AnswerList
        }
        UploadNewAssignmentResult()
    } // end of SubmitOnTapHandler

    /*===========================================
    summary: 點選 聲音播放
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function AudioPlayOnTapHandler(AudioUrl, QuestionIndex)
    {
        console.log(COMP_NAME + ".AudioPlayOnTapHandler: ")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.StopAudio()

        setPlayAudioIndex(QuestionIndex)
        
        window.AudioLibs.PlayAudio(AudioUrl)
    } // end of AudioPlayOnTapHandler
    // #endregion OnTapHandler

    // #region Other Handler
    /*===========================================
    summary: 語言設定 改變 事件
    remarks: 000 Jeff 2022/01/13 Create    Tim幫忙註解
             001 Tim 2022/01/14 實作內容
    ===========================================*/
    function LanguageOnChangeHandler()
    {
        console.log(COMP_NAME + ".LanguageOnChangeHandler: ")

        // 整理 標題資訊 (SubSubSection)
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            mobjDisplaySubSubSection.NameCN = props.SubSectionDef.SubSubSection[2].MajorName
        }
        else
        {
            mobjDisplaySubSubSection.NameCN = props.SubSectionDef.SubSubSection[2].MinorName
        }
        
        marrDisplayQuestion = FormatPDQuestionData(props.LUInfo, mobjTestSheet)

        setUpdateDataTime(new Date().getTime())
    } // end of LanguageOnChangeHandler

    /*===========================================
    summary: 播放聲音 結束事件
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function PlayAudioEndHandler()
    {
        // console.log(COMP_NAME + ".PlayAudioEndHandler: ")    // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".PlayAudioEndHandler BEGIN")

        setPlayAudioIndex(-1)
    } // end of PlayAudioEndHandler

    /*===========================================
    summary: 作答輸入框 改變事件
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function AnswerTextOnChangeHandler(e, StateAnswerArray, QuestionIndex)
    {
        console.log(COMP_NAME + ".AnswerTextOnChangeHandler: ", e)
        // console.log(COMP_NAME + ".AnswerTextOnChangeHandler e.target.value:", e.target.value)

        let arrAnswerText = JSON.parse(JSON.stringify(StateAnswerArray))
        arrAnswerText[QuestionIndex] = e.target.value

        setAnswerArray(arrAnswerText)

        // 檢查 是否 全部題目都有作答
        let blnIsAllSelected = CheckIsAllAnswerKey(arrAnswerText)

        if (blnIsAllSelected)
        {
            mobjTestSheet.Dirty = true
        }
        else
        {
            mobjTestSheet.Dirty = false
        }

        setUpdateDataTime(new Date().getTime())
    } // end of AnswerTextOnChangeHandler
    // #endregion Other Handler

    // #region LoadingMask and Alert
    /*===========================================
    summary: 開啟 LoadingMask
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log("OpenLoadingMask: ", LoadingMsg)

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 LoadingMask
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        let objCallbackData = {
            "Action": "ShowAlertWindow",
            "AlertObject": AlertObject
        }
        props.CallbackRef(objCallbackData)
    } // end of ShowAlert
    // #endregion LoadingMask and Alert

    // #region Component Callback
    /*===========================================
    summary: 歷史紀錄視窗 Callback
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function HistoryWindowCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".HistoryWindowCallback: ", CallbackObj)

        let enumTestSheeMode = -1
        if (CallbackObj.Action === "HistoryWindowDetail")
        {
            console.log("HistoryWindowCallback.DetailOnTap")
            console.log("CallbackObj.AssignmentIndex:", CallbackObj.AssignmentIndex)

            mintIndex4HistoryItemToShow = parseInt(CallbackObj.AssignmentIndex)
            enumTestSheeMode = TestSheetModeEnum.History
        }

        if (enumTestSheeMode !== -1)
        {
            SetTestSheetObject(enumTestSheeMode)

            marrDisplayQuestion = FormatPDQuestionData(props.LUInfo, mobjTestSheet)
            setUpdateDataTime(new Date().getTime())
            console.log(COMP_NAME + ".HistoryWindowCallback marrDisplayQuestion: ", marrDisplayQuestion)
        } // end of if (enumTestSheeMode !== -1)
    } // end of HistoryWindowCallback

    function GlossaryWindowCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".GlossaryWindowCallback.CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "CloseShowGlossary")
        {
            console.log("GlossaryWindowCallback.CloseShowGlossary")
            RegisterAudioEvent() // 因為開啟GlossaryWindow時 Audio Event被註冊過去 所以關閉GlossaryWindow時 要再註冊回此
        }
    }
    // #endregion Component Callback

    // #region Other Functions

    function RegisterAudioEvent()
    {
        console.log(COMP_NAME + ".RegisterAudioEvent")

        // window.AudioLibs.RegisterEventHandlerRef(PlayAudioCanPlayHandler, window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
    }

	function RegisterGlossaryCallback()
    {
        console.log(COMP_NAME + ".RegisterGlossaryCallback: ")
        // 因為ToolBarTopUnit點擊Glossary開啟後 會搶走AudioEnded, AudioCanPlay事件 所以如果LU有使用Audio Event 就必須在Glossary關閉時 需呼叫mobjCallerInfoForGlossaryWindow.CallbackRef 觸發 讓Audio Event再次註冊到LU
        let objCallbackData = {
            "Action": "RegisterGlossaryCallback",
            "CallbackRef": GlossaryWindowCallback
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterGlossaryCallback()
    {
        console.log(COMP_NAME + ".UnregisterGlossaryCallback: ")
        let objCallbackData = {
            "Action": "UnregisterGlossaryCallback"
        }
        props.CallbackRef(objCallbackData)
    } 

    /*===========================================
    summary: 註冊 語言改變事件
    remarks: 000 Jeff 2022/01/13 Create  Tim幫忙註解
    ===========================================*/
    function RegisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".RegisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "RegisterLanguageChangeHandler",
            "Function": LanguageOnChangeHandler
        }
        props.CallbackRef(objCallbackData)
    } // end of RegisterLanguageChangeHandler

    /*===========================================
    summary: 反註冊 語言改變事件
    remarks: 000 Jeff 2022/01/13 Create  Tim幫忙註解
    ===========================================*/
    function UnregisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".UnregisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "UnregisterLanguageChangeHandler"
        }
        props.CallbackRef(objCallbackData)
    } // end of UnregisterLanguageChangeHandler
    
    /*===========================================
    summary: 取得 必要資料 流程 開始
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function GetPrerequisiteDataProcessBegin()
    {
        console.log(COMP_NAME + ".GetPrerequisiteDataProcessBegin")

        // 1 Steps:
        // 1. History

        // Func: "GetNewAssignmentAssignAnswer"
        // AssignID: -1
        // Assignee: 459
        // BookCategoryID: "03"
        // LUCatSeqNo: 14
        // LessonID: "03001"

        mobjCallParam = {
            "Assignee": window.gSession.Acc.ID,
            "BookCategoryID": mstrBookCatID,
            "LessonID": props.LessonID,
            "LUCatSeqNo": props.LUInfo.LUCatSeqNo,
            "AssignID": -1
        }
        GetAssignmentAssignAnswer()
    } // end of GetPrerequisiteDataProcessBegin

    /*===========================================
    summary: 取得 必要資料 流程 結束
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function GetPrerequisiteDataProcessEnd()
    {
        console.log(COMP_NAME + ".GetPrerequisiteDataProcessEnd")

        console.log("mobjLUCacheContext.AssigementHistoryList: ", mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext])

        let enumTestSheeMode = TestSheetModeEnum.New
        if (
            (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext] !== null) &&
            (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.length > 0)
            )
        {
            enumTestSheeMode = TestSheetModeEnum.History
            mintIndex4HistoryItemToShow = 0
        }
        console.log("enumTestSheeMode: ", enumTestSheeMode)
        SetTestSheetObject(enumTestSheeMode)

        // 整理 標題資訊 (SubSubSection)
        mobjDisplaySubSubSection.NameEN = props.SubSectionDef.SubSubSection[2].Name
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            mobjDisplaySubSubSection.NameCN = props.SubSectionDef.SubSubSection[2].MajorName
        }
        else
        {
            mobjDisplaySubSubSection.NameCN = props.SubSectionDef.SubSubSection[2].MinorName
        }

        marrDisplayQuestion = FormatPDQuestionData(props.LUInfo, mobjTestSheet)

        InitBlockedInstructor()

        setUpdateDataTime(new Date().getTime())
    } // end of GetPrerequisiteDataProcessEnd

    /*===========================================
    summary: 初始化 鎖住作答
    remarks: 000 Tim 2022/03/14 Create
    ===========================================*/
    function InitBlockedInstructor()
    {
        console.log(COMP_NAME + ".InitBlockedInstructor: ")

        let intAccountRole = window.Globals.GetClassAccountRole(window.gSession.Acc.CurrentClassIndex)

        if (intAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT)
        {
            let intAssignCount = 0
            if (
                (typeof(mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext]) !== "undefined") &&
                (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext] !== null) &&
                (typeof(mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList) !== 'undefined') &&
                (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList !== null) &&
                (mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.length > 0)
                )
            {
                intAssignCount = mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.length
            }
            console.log(COMP_NAME + ".InitBlockedInstructor intAssignCount: ", intAssignCount)
            // console.log(COMP_NAME + ".InitBlockedInstructor LUCatSeqNo: ", props.LUInfo.LUCatSeqNo)
            // console.log(COMP_NAME + ".InitBlockedInstructor IsDCPSectionPracticeShow: ", window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionPracticeShow)
            // console.log(COMP_NAME + ".InitBlockedInstructor IsDCPSectionHWShow: ", window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionHWShow)
            // console.log(COMP_NAME + ".InitBlockedInstructor DCPTestedCountMax: ", window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax)
            // 學生身份
            let strMsg = ""
            if (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPSectionPracticeShow) === 0)
            {
                // 老師關閉 Practice
                strMsg = window.gAppUI.MSG_Alert_Msg_BlockedInstructor
            }
            else if (
                (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax) <= 2) &&
                (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax) <= intAssignCount)
                )
            {
                // 作答次數 超過 設定值
                if (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].DCPTestedCountMax) === 1)
                {
                    // 作答次數 超過 一次
                    strMsg = window.gAppUI.MSG_Alert_Msg_TestedCountExceededOnce
                }
                else
                {
                    // 作答次數 超過 兩次
                    strMsg = window.gAppUI.MSG_Alert_Msg_TestedCountExceededTwice
                }
            }

            if (strMsg !== "")
            {
                mstrMessage4BlockedInstructor = strMsg
                setIsBlockedInstructor(true)
            } // end of if (strMsg !== "")
        } // end of if (intAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT)
    } // end of InitBlockedInstructor

    /*===========================================
    summary: 設定 目前 答案物件 與 狀態
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function SetTestSheetObject(TestSheetMode)
    {
        console.log(COMP_NAME + ".SetTestSheetObject: ", TestSheetMode)

        console.log("mobjLUCacheContext.AssigementHistoryList: ", mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext])

        let objHistoryAnswerSheet = null
        let arrHistoryAnswerList = []

        mobjTestSheet.Mode = TestSheetMode
        mobjTestSheet.Score = -1
        mobjTestSheet.Dirty = false
        mobjTestSheet.AnswerList = []
        mobjTestSheet.AssignID = -1

        if (TestSheetMode === TestSheetModeEnum.History)
        {
            console.log("mintIndex4HistoryItemToShow: ", mintIndex4HistoryItemToShow)
            objHistoryAnswerSheet = mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList[mintIndex4HistoryItemToShow]
            arrHistoryAnswerList = objHistoryAnswerSheet.AnswerList

            mobjTestSheet.AssignID = objHistoryAnswerSheet.AssignID
            if (objHistoryAnswerSheet.Score !== null)
            {
                mobjTestSheet.Score = parseFloat(objHistoryAnswerSheet.Score)
            }
            else
            {
                mobjTestSheet.Score = null
            }
        }

        let arrTempAnswer = []
        let objTempAnswer = null

        // AnswerID: "3297"
        // LessonID: "3001"
        // SentenceSeqNo: "77"
        // PDAnswer: "2"
        // TeacherFeedbackText: null        

        if (TestSheetMode === TestSheetModeEnum.History)
        {
            arrTempAnswer = arrHistoryAnswerList
            console.log("Temp arrTempAnswer: ", arrTempAnswer)
        }

        let intIndex4Sentence = 0
        let intCount4Sentence = props.LUInfo.Sentence.length

        let objAnswer = null

        for (intIndex4Sentence = 0; intIndex4Sentence < intCount4Sentence; intIndex4Sentence++)
        {
            let strSentenceSeqNo = props.LUInfo.Sentence[intIndex4Sentence].SentenceSeqNo

            if (TestSheetMode === TestSheetModeEnum.History)
            {
                objTempAnswer = arrTempAnswer.find(AnswerData => parseInt(AnswerData.SentenceSeqNo) === parseInt(strSentenceSeqNo))

                console.log("History objTempAnswer: ", objTempAnswer)

                objAnswer = {
                    "AnswerID": objTempAnswer.AnswerID,
                    "SentenceSeqNo": objTempAnswer.SentenceSeqNo,
                    "PDAnswer": objTempAnswer.PDAnswer,
                    "TeacherFeedbackText": objTempAnswer.TeacherFeedbackText
                }
            }
            else if (TestSheetMode === TestSheetModeEnum.New)
            {
                objAnswer = {
                    "AnswerID": null,
                    "SentenceSeqNo": parseInt(strSentenceSeqNo).toString(),
                    "PDAnswer": null,
                    "TeacherFeedbackText": null
                }
            }

            console.log("objAnswer: ", objAnswer)
            mobjTestSheet.AnswerList.push(objAnswer)

        } // end of for (intIndex4Sentence = 0;

        InitBlockedInstructor()

        console.log(COMP_NAME + ".SetTestSheetObject END mobjTestSheet: ", mobjTestSheet)
    } // end of SetTestSheetObject

    /*===========================================
    summary: 初始化 填空題 顯示資料
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function FormatPDQuestionData(LUInfo, TestSheet)
    {
        console.log(COMP_NAME + ".FormatPDQuestionData: ", LUInfo, TestSheet)

        let arrSentence = LUInfo.Sentence
        let arrDisplayQuestion = []
        let objDisplayQuestion = null

        let intSentenceIndex = 0
        let intSentenceCount = arrSentence.length
        let arrAnswer = TestSheet.AnswerList
        let objAnswer = null

        let strPDAnswer = ""
        let arrPDAnswer = []

        // Sentence: Array(8)
        //     0:
        //     AudioFN: "01001_pindictation_01.mp3"
        //     IsCheck: true
        //     KBPinyin: "ni3men"
        //     KeyInAns: "2"
        //     MajorText: "你们"
        //     MinorText: "你們"
        //     Pinyin: null
        //     SentenceSeqNo: "077"
        //     Text: null

        for (intSentenceIndex = 0; intSentenceIndex < intSentenceCount; intSentenceIndex++)
        {
            objDisplayQuestion = {
                "SentenceSeqNo": arrSentence[intSentenceIndex].SentenceSeqNo,
                "QuestionText": "",
                "AudioUrl": window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Audio, arrSentence[intSentenceIndex].AudioFN),
                "PDAnswer": "",
                "AnswerID": 0,
                "TeacherFeedbackText": ""
            }
            
            let intSentenceSeqNo = parseInt(arrSentence[intSentenceIndex].SentenceSeqNo)

            // 找出 顯示 題目文字
            if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
            {
                objDisplayQuestion.QuestionText = arrSentence[intSentenceIndex].MajorText
            }
            else
            {
                objDisplayQuestion.QuestionText = arrSentence[intSentenceIndex].MinorText
            }

            // 找出 使用者 選擇的答案
            objAnswer = arrAnswer.find(AnswerData => (parseInt(AnswerData.SentenceSeqNo) === intSentenceSeqNo))
            
            if (
                (typeof(objAnswer) !== 'undefined') &&
                (objAnswer !== null)
                )
            {
                objDisplayQuestion.AnswerID = objAnswer.AnswerID
                objDisplayQuestion.PDAnswer = objAnswer.PDAnswer
                strPDAnswer = objAnswer.PDAnswer

                if (
                    (typeof(objAnswer.TeacherFeedbackText) !== 'undefined') &&
                    (objAnswer.TeacherFeedbackText !== null) &&
                    (objAnswer.TeacherFeedbackText !== "")
                    )
                {
                    objDisplayQuestion.TeacherFeedbackText = objAnswer.TeacherFeedbackText
                } // end of if (objAnswer.TeacherFeedbackText !== null)
            } // end of if (objAnswer !== null)
            arrPDAnswer.push(strPDAnswer)

            arrDisplayQuestion.push(objDisplayQuestion)
        } // end of for (intSentenceIndex = 0;

        setAnswerArray(arrPDAnswer)

        console.log(COMP_NAME + ".FormatPDQuestionData END arrDisplayQuestion: ", arrDisplayQuestion)

        return arrDisplayQuestion
    } // end of FormatPDQuestionData

    /*===========================================
    summary: 前往 指定的 Learning Unit
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function GoToLU(LUCatSeqNo)
    {
        console.log(COMP_NAME + ".GoToLU: ")

        let objCallbackData = {
            "LUCatSeqNo": LUCatSeqNo,
            "Action": "GoToLU"
        }
        console.log("objCallbackData:", objCallbackData)
        props.CallbackRef(objCallbackData)
    } // end of GoToLU

    /*===========================================
    summary: 執行儲存答案
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function CheckIsAllAnswerKey(AnswerTextList)
    {
        // console.log(COMP_NAME + ".CheckIsAllAnswerKey: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".CheckIsAllAnswerKey BEGIN")
        
        let intIndex = 0
        let intCount = AnswerTextList.length
        let blnIsAllSelected = true

        while (blnIsAllSelected && (intIndex < intCount))
        {
            if (
                (typeof(AnswerTextList[intIndex]) === 'undefined') ||
                (AnswerTextList[intIndex] === null) ||
                (AnswerTextList[intIndex] === "")
                )
            {
                blnIsAllSelected = false
            }

            intIndex++
        } // end of while (intSQIndex

        console.log(COMP_NAME + ".CheckIsAllAnswerKey END blnIsAllSelected: ", blnIsAllSelected)
        
        return blnIsAllSelected
    } // end of CheckIsAllAnswerKey

    /*===========================================
    summary: Submit後 更新 Cache資料
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function UpdateCacheSinceSubmit(DataFromSubmit)
    {
        console.log(COMP_NAME + ".UpdateCacheSinceSubmit: ", DataFromSubmit)

        let objTestTime = new Date()

        let objNewAssign = {
            "AnswerList": DataFromSubmit.AnswerList,
            "AssignID": DataFromSubmit.AssignID,
            "Score": DataFromSubmit.Score,
            "TestedTime": objTestTime.ToBCUTCString()
        }

        // 更新 History 資料
        console.log("objNewAssign: ", objNewAssign)
        mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.unshift(objNewAssign)

        setUpdateDataTime(new Date().getTime())
    } // end of UpdateCacheSinceSubmit
    // #endregion Other Functions

    // #region Get ClassName and Style
    /*===========================================
    summary: 取得 送出作答資料按鈕 Cls
    remarks: 000 Tim 2022/01/11 Create
             001 Tim 2022/03/14 補上 BlockedInstructor 機制
    ===========================================*/
    function GetSubmitButtonCls(TestSheet, StateIsBlockedInstructor)
    {
        let objCls = cssPracticePinyinDictation.btnScoreToolMainDisable

        if (
            (!StateIsBlockedInstructor) &&
            (TestSheet.Dirty)
            )
        {
            objCls = cssPracticePinyinDictation.btnScoreToolMain
        }

        return objCls
    } // end of GetSubmitButtonCls

    /*===========================================
    summary: 取得 歷史紀錄按鈕 Cls
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function GetHistoryButtonMainCls(HistoryData)
    {
        let objCls = cssPracticePinyinDictation.btnScoreToolMainDisable
        // 有 答題完成的歷史答案
        if (
            (typeof (HistoryData) !== "undefined") &&
            (HistoryData !== null) &&
            (typeof (HistoryData.NewAssignList) !== "undefined") &&
            (HistoryData.NewAssignList !== null) &&
            (HistoryData.NewAssignList.length > 0)
            ) 
        {
            objCls = cssPracticePinyinDictation.btnScoreToolMain
        }
        return objCls
    } // end of GetHistoryButtonMainCls

    /*===========================================
    summary: 取得 聲音播放按鈕 Cls
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function GetAudioPlayCls(StatePlayAudioIndex, QuestionIndex) 
    {
        let objCls = cssPracticePinyinDictation.btnAudioPlay

        if (StatePlayAudioIndex === QuestionIndex)
        {
            objCls = cssPracticePinyinDictation.btnAudioPlayDisabled
        }

        return objCls
    } // end of GetAudioPlayCls

    /*===========================================
    summary: 取得 再做一次 按鈕 Cls
    remarks: 000 Tim 2022/03/14 Create
    ===========================================*/
    function GetRetryButtonCls(StateIsBlockedInstructor)
    {
        let objCls = cssPracticePinyinDictation.btnScoreToolMain

        if (StateIsBlockedInstructor)
        {
            objCls = cssPracticePinyinDictation.btnScoreToolMainDisable
        }

        return objCls
    } // end of GetRetryButtonCls
    // #endregion Get ClassName and Style

    // #region Web Service After Process
    /*===========================================
    summary: 上傳 考卷答案 資料 後續處理
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function UploadNewAssignmentResultAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".UploadNewAssignmentResultAfterProcess: ", ReturnData)

        UpdateCacheSinceSubmit(ReturnData)

        mobjCallParam = null
        mintIndex4HistoryItemToShow = 0

        SetTestSheetObject(TestSheetModeEnum.History)
        marrDisplayQuestion = FormatPDQuestionData(props.LUInfo, mobjTestSheet)
        setUpdateDataTime(new Date().getTime())
        console.log(COMP_NAME + ".UploadNewAssignmentResultAfterProcess marrDisplayQuestion: ", marrDisplayQuestion)
    } // end of UploadNewAssignmentResultAfterProcess

    /*===========================================
    summary: 取得考卷 歷史紀錄 資料 後續流程
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function GetAssignmentAssignAnswerAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetAssignmentAssignAnswerAfterProcess: ", ReturnData)

        // 更新 Cache
        mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext] = ReturnData

        console.log("完成 Step 1, 不需進行 Step 2")
        GetPrerequisiteDataProcessEnd()
    } // end of GetAssignmentAssignAnswerAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 取得考卷 歷史紀錄 資料
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function GetAssignmentAssignAnswer()
    {
        console.log(COMP_NAME + ".GetAssignmentAssignAnswer: ", props.LUInfo.LUCatSeqNo)

        let objRetryFuncRef = GetAssignmentAssignAnswer
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetAssignmentAssignAnswerCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetAssignmentAssignAnswer)

            let objCallData = {
                "Func": "GetNewAssignmentAssignAnswer",
                "Assignee": mobjCallParam.Assignee,
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "LessonID": mobjCallParam.LessonID,
                "LUCatSeqNo": mobjCallParam.LUCatSeqNo,
                "AssignID": mobjCallParam.AssignID
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetAssignmentAssignAnswer

    /*===========================================
    summary: 取得考卷 歷史紀錄 資料 Callback
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function GetAssignmentAssignAnswerCallback(Return)
    {
        console.log(COMP_NAME + ".GetAssignmentAssignAnswerCallback: ", Return)
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetAssignmentAssignAnswer_No
        let strErrorTitle = window.gAppUI.ERR_GetAssignmentAssignAnswer_Title
        let strErrMsg = window.gAppUI.ERR_GetAssignmentAssignAnswer_Msg

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    // NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg, strRetryBackRoute, blnReLaunch, strBackRoute)
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("GetAssignmentAssignAnswerCallback: ErrNo: ", Return.ErrNo)
            console.log("GetAssignmentAssignAnswerCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetAssignmentAssignAnswerCallback Return.Data", Return.Data)

            GetAssignmentAssignAnswerAfterProcess(Return.Data)
        }
    } // end of GetAssignmentAssignAnswerCallback

    /*===========================================
    summary: 上傳 考卷答案 資料
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function UploadNewAssignmentResult()
    {
        // console.log(COMP_NAME + ".UploadNewAssignmentResult: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".UploadNewAssignmentResult BEGIN")
        let objRetryFuncRef = UploadNewAssignmentResult
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_UploadAssignmentResult_Title, window.gAppUI.ERR_UploadAssignmentResult_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = UploadNewAssignmentResultCallback

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_UploadNewAssignmentResult)

            let objCallData = {
                "Func": "UploadNewAssignmentResult",
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "LessonID": mobjCallParam.LessonID,
                "ClassID": mobjCallParam.ClassID,
                "LUCatSeqNo": mobjCallParam.LUCatSeqNo,
                "Answer": JSON.stringify(mobjCallParam.AnswerList)
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of UploadNewAssignmentResult

    /*===========================================
    summary: 上傳 考卷答案 資料 Callback
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function UploadNewAssignmentResultCallback(Return)
    {
        console.log(COMP_NAME + ".UploadNewAssignmentResultCallback: ", Return)
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_UploadAssignmentTmpResult_No
        let strErrorTitle = window.gAppUI.ERR_UploadAssignmentResult_Title
        let strErrMsg = window.gAppUI.ERR_UploadAssignmentResult_Msg

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("UploadNewAssignmentResultCallback: ErrNo: ", Return.ErrNo)
            console.log("UploadNewAssignmentResultCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("UploadNewAssignmentResultCallback Return.Data", Return.Data)

            UploadNewAssignmentResultAfterProcess(Return.Data)
        }
    } // end of UploadNewAssignmentResultCallback
    // #endregion Web Service

    // #region Component
    /*===========================================
    summary: No Cell 顯示Component  
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function ComponentNoCell( {QuestionIndex} )
    {   
        let strNo = (QuestionIndex + 1).toString() + "."

        return(
            <div className={cssPracticePinyinDictation.divNoCell}>
                {strNo}
            </div>
        )
    } // end of ComponentNoCell

    /*===========================================
    summary: Submit or Start 按鈕 顯示Component  
    remarks: 000 Tim 2022/01/11 Create
             001 Tim 2022/03/14 補上 BlockedInstructor 機制
    ===========================================*/
    function ComponentSubmitOrStartButton( {TestSheet, StateIsBlockedInstructor} )
    {  
        let objButtonBlock = null
        if (TestSheet.Mode === TestSheetModeEnum.History)
        {
            // Start
            objButtonBlock =    <div className={GetRetryButtonCls(StateIsBlockedInstructor)} onClick={() => TryAgainOnTapHandler()}>
                                    <div className={cssPracticePinyinDictation.divTryAgainIcon}/>
                                    <div className={cssPracticePinyinDictation.divScoreToolButtonText}>
                                        {PackageVariablesLibs.UISettings.BTN_Retry}
                                    </div>
                                </div>
        }
        else if (TestSheet.Mode === TestSheetModeEnum.New)
        {
            objButtonBlock =    <div className={GetSubmitButtonCls(TestSheet, StateIsBlockedInstructor)} onClick={() => SubmitOnTapHandler(answerArray)}>
                                    <div className={cssPracticePinyinDictation.divSubmitIcon}/>
                                    <div className={cssPracticePinyinDictation.divScoreToolButtonText}>
                                        {window.gAppUI.BTN_Submit}
                                    </div>
                                </div>
        }

        return(
            <>
                <div className={cssPracticePinyinDictation.divScoreToolBar}/>

                {objButtonBlock}
            </>
        )
    } // end of ComponentSubmitOrStartButton

    /*===========================================
    summary: 分數 區域 顯示Component  
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function ComponentHistoryButton( {HistoryData} )
    {  
        return(
            <>
                <div className={cssPracticePinyinDictation.divScoreToolBar}/>
                
                <div className={GetHistoryButtonMainCls(HistoryData)} 
                        onClick={() => HistoryOnTapHandler()}>
                    <div className={cssPracticePinyinDictation.divHistoryIcon}/>
                    <div className={cssPracticePinyinDictation.divScoreToolButtonText}>
                        {window.gAppUI.BTN_History}
                    </div>
                </div>
            </>
        )
    } // end of ComponentHistoryButton

    /*===========================================
    summary: 分數 區域 顯示Component  
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function ComponentScoreArea( {TestSheetScore} )
    {  
        let strScore = window.gAppUI.LBL_NotScore
        if (
            (typeof(TestSheetScore) !== 'undefined') &&
            (TestSheetScore !== null) &&
            (parseInt(TestSheetScore) >= 0)
            )
        {
            strScore = TestSheetScore
        }

        return(
            <>
                <div className={cssPracticePinyinDictation.divScoreToolTitle}>
                    {window.gAppUI.LBL_YourScore}:
                </div>
                <div className={cssPracticePinyinDictation.divScoreToolScore}>
                    {strScore}
                </div>
            </>
        )
    } // end of ComponentScoreArea

    /*===========================================
    summary: 中文標題 顯示Component  
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function ComponentTitleCN( {PropsSubSectionDef} )
    {   
        let strTitleCN = ""
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            strTitleCN = PropsSubSectionDef.MajorName
        }
        else
        {
            strTitleCN = PropsSubSectionDef.MinorName
        }

        return(
            <div className={cssPracticePinyinDictation.divLUTitleTextCN}>
                {strTitleCN}
            </div>
        )
    } // end of ComponentTitleCN
    // #endregion Component

    // #region Render
    /*===========================================
    summary: Render Blocked Instructor 的顯示
    remarks: 000 Tim 2022/03/14 Create
    ===========================================*/
    function RenderBlockedInstructorWrapper(StateIsBlockedInstructor)
    {
        if (StateIsBlockedInstructor)
        {
            return (
                <div className={cssPracticePinyinDictation.divBlockedInstructor}>
                    {mstrMessage4BlockedInstructor}
                </div>
            )
        }
        else 
        {
            return ""
        }
    } // end of RenderBlockedInstructorWrapper

    function RenderGoogleClassrommButton()
    {
        let objBlockGoogleClassroomButton = null
        if (!window.gConfig.ForChina)
        {
            // 非China
            if (!window.gSession.App.InApp)
            {
                let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(mstrLUCatSeqNo)
                console.log("strUrl: ", encodeURIComponent(strUrl))            
                objBlockGoogleClassroomButton = <GoogleShareToClassRoom
                    itemType="assignment"
                    url={strUrl}
                    size={32}
                    theme="classic"
                />
            }
            else
            {
                // In App
                console.log("window.gSession.App.AppVersion:", window.gSession.App.AppVersion)
                var intCheckResult = GlobalLibs.CheckWithCurrentVersion(window.gSession.App.AppVersion, "2.0.8.2");
                if(intCheckResult === -1)
                {
                    // DCP iOS App版號 2.0.8.1以前(含) e.g. iOS 2.0.8.1, 2.0.8.0, 2.0.7 ...
                    objBlockGoogleClassroomButton = null
                }
                else
                {
                    // DCP iOS App版號 2.0.8.2以後(含)
                    objBlockGoogleClassroomButton = <div className={cssPracticePinyinDictation.btnShare2GoogleClassroom4App} onClick={() => Share2GoogleClassroom4AppOnTapHandler()} />
                }
            }
        }
        
        return objBlockGoogleClassroomButton
    } // end of RenderGoogleClassrommButton

    /*===========================================
    summary: 題目下方留白區域 顯示Component  
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function RenderResultSpacerWrapper(TestSheet)
    {   
        if (
            // 作答模式 不顯示正確答案
            // 老師設定 不顯示正確答案
            (
                (TestSheet.Mode === TestSheetModeEnum.New) ||
                    (
                        (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT) &&

                        (typeof(window.gSession.Acc.CurrentClassIndex) !== 'undefined') &&
                        (window.gSession.Acc.CurrentClassIndex !== null) &&
                        (parseInt(window.gSession.Acc.CurrentClassIndex) >= 0) &&

                        (typeof(window.gSession.Acc.Class) !== 'undefined') &&
                        (window.gSession.Acc.Class !== null) &&
                        (window.gSession.Acc.Class.length !== null) &&

                        (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
                        (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&
                        
                        (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) !== 'undefined') &&
                        (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow !== null) &&
                        (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) === 0)
                    )
            ) &&
            // 且 沒有老師評分
            (
                (typeof(TestSheet.Score) === 'undefined') ||
                (TestSheet.Score === null) ||
                (parseInt(TestSheet.Score) < 0)
            )
            )
        {
            // 不顯示 留白
        }
        else
        {
            return(
                <div className={cssPracticePinyinDictation.divResultSpacer}/>
            )
        }
    } // end of RenderResultSpacerWrapper

    /*===========================================
    summary: Render Teacher Feedback 的顯示
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function RenderTeacherFeedbackWrapper(QuestionData, TestSheetScore)
    {
        if (
            (typeof(TestSheetScore) !== 'undefined') &&
            (TestSheetScore !== null) &&
            (parseInt(TestSheetScore) >= 0)
            )
        {
            return (
                <div className={cssPracticePinyinDictation.divSuggestedTeacherFeedbackMain}>
                    <div className={cssPracticePinyinDictation.divSuggestedTeacherFeedbackTitle}>
                        {window.gAppUI.LBL_TeachersComments}:
                    </div>
                    <div className={cssPracticePinyinDictation.divFeedback4Result}>
                        {QuestionData.TeacherFeedbackText}
                    </div>
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderTeacherFeedbackWrapper

    /*===========================================
    summary: 正確答案區域 顯示Component  
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function RenderSuggestedAnswerAreaWrapper(QuestionText, TestSheetMode)
    {   
        if (
            (TestSheetMode === TestSheetModeEnum.New) ||
                (
                    (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT) &&

                    (typeof(window.gSession.Acc.CurrentClassIndex) !== 'undefined') &&
                    (window.gSession.Acc.CurrentClassIndex !== null) &&
                    (parseInt(window.gSession.Acc.CurrentClassIndex) >= 0) &&

                    (typeof(window.gSession.Acc.Class) !== 'undefined') &&
                    (window.gSession.Acc.Class !== null) &&
                    (window.gSession.Acc.Class.length !== null) &&

                    (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
                    (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&
                    
                    (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) !== 'undefined') &&
                    (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow !== null) &&
                    (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) === 0)
                )
            )
        {
            // 作答模式 不顯示正確答案
            // 老師設定 不顯示正確答案
        }
        else
        {
            return(
                <>
                    <div className={cssPracticePinyinDictation.divSuggestedAnswerTitle}>
                        {window.gAppUI.LBL_SuggestedAnswer}
                    </div>

                    <div className={cssPracticePinyinDictation.divSuggestedAnswerText}>
                        {QuestionText}
                    </div>
                </>
            )
        }
    } // end of RenderSuggestedAnswerAreaWrapper

    /*===========================================
    summary: 學生作答區域 顯示 
    remarks: 000 Tim 2022/01/11 Create
             001 Tim 2022/03/14 補上 BlockedInstructor 機制
    ===========================================*/
    function RenderStudentAnswerAreaWrapper(QuestionData, QuestionIndex
        , StateAnswerArray, TestSheetMode, StateIsBlockedInstructor)
    {   
        if (
            (StateIsBlockedInstructor) ||
            (TestSheetMode === TestSheetModeEnum.History)
            )
        {
            return( 
                <div className={cssPracticePinyinDictation.divAnswerText}>
                    {QuestionData.PDAnswer}
                </div>
            )
        }
        else if (TestSheetMode === TestSheetModeEnum.New)
        {
            return(
                <>
                    <label htmlFor="txtAnswer" className={cssPracticePinyinDictation.divHidden}>
                        {window.gAppUI.LBL_AnswerPlaceHolder}
                    </label>
                    <input id="txtAnswer" type="text"
                        className={cssPracticePinyinDictation.txtInput}
                        value={StateAnswerArray[QuestionIndex]}
                        onChange={(event) => AnswerTextOnChangeHandler(event, StateAnswerArray, QuestionIndex)}
                        maxLength={MAX_ANSWER_CHARACHERS}
                        />
                </>
            )
        }
    } // end of RenderStudentAnswerAreaWrapper

    /*===========================================
    summary: Render Answer Cell 的顯示
    remarks: 000 Tim 2022/01/11 Create
             001 Tim 2022/03/14 補上 BlockedInstructor 機制
    ===========================================*/
    function RenderAnswerCellWrapper(QuestionData, QuestionIndex)
    {
        return (
            <div className={cssPracticePinyinDictation.divAnswerCell}>
                {RenderStudentAnswerAreaWrapper(QuestionData, QuestionIndex, answerArray, mobjTestSheet.Mode, isBlockedInstructor)}

                {RenderSuggestedAnswerAreaWrapper(QuestionData.QuestionText, mobjTestSheet.Mode)}

                {RenderTeacherFeedbackWrapper(QuestionData, mobjTestSheet.Score)}

                {RenderResultSpacerWrapper(mobjTestSheet)}
            </div>
        )
    } // end of RenderAnswerCellWrapper

    /*===========================================
    summary: Render Question Unit 的顯示
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function RenderQuestionUnitWrapper(QuestionData, QuestionIndex)
    {
        return (
            <>
                <ComponentNoCell QuestionIndex={QuestionIndex} />

                <div className={GetAudioPlayCls(playAudioIndex, QuestionIndex)} onClick={() => AudioPlayOnTapHandler(QuestionData.AudioUrl, QuestionIndex)}/>

                {RenderAnswerCellWrapper(QuestionData, QuestionIndex)}

                <div className={cssPracticePinyinDictation.divSpacerCell}/>
            </>
        )
    } // end of RenderQuestionUnitWrapper

    /*===========================================
    summary: Render QuestionArea 的顯示
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function RenderQuestionAreaWrapper()
    {
        return (
            <div className={cssPracticePinyinDictation.divQuestionArea}>
                {marrDisplayQuestion.map((QuestionData, QuestionIndex) =>
                    <div key={QuestionIndex} className={cssPracticePinyinDictation.divQuestionMain}>
                        {RenderQuestionUnitWrapper(QuestionData, QuestionIndex)}
                    </div>
                )}
            </div>
        )
    } // end of RenderQuestionAreaWrapper

    /*===========================================
    summary: Render ScoreToolArea 的顯示
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function RenderScoreToolAreaWrapper()
    {
        return (
            <div className={cssPracticePinyinDictation.divScoreToolArea}>
                <ComponentScoreArea TestSheetScore={mobjTestSheet.Score} />

                <ComponentHistoryButton HistoryData={mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext]} />

                <ComponentSubmitOrStartButton TestSheet={mobjTestSheet} StateIsBlockedInstructor={isBlockedInstructor}/>
            </div>
        )
    } // end of RenderScoreToolAreaWrapper

    /*===========================================
    summary: Render SubSub 標題區域 的顯示
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function RenderSubSubTitleAreaWrapper()
    {
        return (
            <div className={cssPracticePinyinDictation.divSubSubTitleArea}>
                <div className={cssPracticePinyinDictation.divSubSubTitleSubTopArea}>
                    <div className={cssPracticePinyinDictation.divSubSubTitle}>
                        {mobjDisplaySubSubSection.NameEN}
                    </div>

                    <div className={cssPracticePinyinDictation.divSubSubDividerBar}/>
                    
                    <div className={cssPracticePinyinDictation.divSubSubTitle}>
                        {mobjDisplaySubSubSection.NameCN}
                    </div>

                    <div className={cssPracticePinyinDictation.btnInfo} onClick={() => InfoOnTapHandler()}/>
                </div>

                <div className={cssPracticePinyinDictation.divInstructionArea}>
                    {parse(mstrInstruction)}
                </div>
            </div>
        )
    } // end of RenderSubSubTitleAreaWrapper

    /*===========================================
    summary: Render Question Unit 的顯示
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function RenderContentToolAreaWrapper()
    {
        return (
            <>
                {RenderSubSubTitleAreaWrapper()}
                {RenderScoreToolAreaWrapper()}
            </>
        )
    } // end of RenderContentToolAreaWrapper
    
    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2022/01/11 Create
             001 Tim 2022/03/14 補上 BlockedInstructor 機制
    ===========================================*/
    function RenderContentWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <div className={cssPracticePinyinDictation.divContentArea}>
                    {RenderContentToolAreaWrapper()}
                    
                    {RenderQuestionAreaWrapper()}

                    {RenderBlockedInstructorWrapper(isBlockedInstructor)}
                </div>
            )
        }
        else 
        {
            return ""
        }
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 右邊 SubSubSection 區塊 的顯示
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function RenderSubSubSectionToolArea()
    {
        return(
            <div className={cssPracticePinyinDictation.divSubSubSectionToolArea}>
                <div className={cssPracticePinyinDictation.btnPinyinPronunciation} onClick={() => SubSubSectionOnTapHandler(window.gDCPLUEnum.PracticePinyinPronunciation)}>
                    {props.SubSectionDef.SubSubSection[0].Name}
                </div>
                <div className={cssPracticePinyinDictation.btnPinyinIdentification} onClick={() => SubSubSectionOnTapHandler(window.gDCPLUEnum.PracticePinyinIdentification)}>
                    {props.SubSectionDef.SubSubSection[1].Name}
                </div>
                <div className={cssPracticePinyinDictation.btnPinyinDictation} >
                    {props.SubSectionDef.SubSubSection[2].Name}
                </div>
            </div>
        )
    } // end of RenderSubSubSectionToolArea

    /*===========================================
    summary: Render Header 左邊區塊 的顯示
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function RenderHeaderLeftAreaWrapper()
    {
        return (
            <div className={cssPracticePinyinDictation.divTitleLeftArea}>
                {RenderGoogleClassrommButton()}

                <div className={cssPracticePinyinDictation.divTitleSubArea}>
                    <div className={cssPracticePinyinDictation.divLessonIcon}/>

                    <div className={cssPracticePinyinDictation.divLUTitleTextEN}>
                        {props.SubSectionDef.Name}
                    </div>

                    <div className={cssPracticePinyinDictation.divDividerBar}/>

                    <ComponentTitleCN PropsSubSectionDef={props.SubSectionDef} />
                </div>
            </div>
        )
    } // end of RenderHeaderLeftAreaWrapper

    /*===========================================
    summary: Render Header 的顯示
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function RenderHeaderWrapper()
    {
        return (
            <>
                {RenderHeaderLeftAreaWrapper()}
                {RenderSubSubSectionToolArea()}
            </>
        )
    } // end of RenderHeaderWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2022/01/11 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <>
                {RenderHeaderWrapper()}
                {RenderContentWrapper(updateDataTime)}
            </>
        )
    } // end of RenderMainWrapper

    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default PracticePinyinDictation